import * as R from 'ramda';

export const capitalizeFirstLetter = string => {
    const capital = R.pipe(R.head, R.toUpper);

    return R.converge(R.concat, [capital, R.tail])(string);
};
